import React, { Component } from 'react'
import PropTypes from 'prop-types'
import * as css from './reg-item-form.scss'
import ImageUploadPreviewer from 'shared/image-upload-previewer/image-upload-previewer'
import { Input } from 'components/forms'
import FavoriteToggle from 'shared/reg-item-form/components/favorite-toggle'
import CategorySelector from './category-selector'
import { REG_ITEM_PLACEHOLDER_TEXT } from 'registry/constants'

export default class GiftCardFields extends Component {
  static propTypes = {
    categories: PropTypes.array,
    regItem: PropTypes.object,
    onRegItemChange: PropTypes.func.isRequired,
    onNewCategoryChange: PropTypes.func.isRequired,
  }

  state = {}

  onImageChange = ({ imgUrl }) => {
    this.props.onRegItemChange({ imgUrl })
  }

  onFavoriteChange = (isChecked) => {
    this.props.onRegItemChange({ isFavorite: isChecked })
  }

  handleChange = (e) => {
    this.props.onRegItemChange({ [e.target.name]: e.target.value })
  }

  render() {
    const regItemFields = this.props.regItem

    return (
      <React.Fragment>
        <div className={css.item}>
          <div className={css.imageContainer}>
            <ImageUploadPreviewer
              imgUrl={regItemFields.imgUrl}
              onChange={this.onImageChange}
            />
          </div>

          <div className={css.itemFields}>
            <Input
              label="Title"
              value={regItemFields.title}
              name="title"
              disabled={true}
            />

            <CategorySelector
              name="categoryId"
              value={regItemFields.categoryId}
              categories={this.props.categories}
              onCategoryChange={this.props.onRegItemChange}
              onCategoryAdd={this.props.onNewCategoryChange}
            />

            <FavoriteToggle
              className={css.flexGrow}
              defaultOn={this.props.regItem.isFavorite}
              onClick={this.onFavoriteChange}
            />
          </div>
        </div>

        <div className="sm-hidden mtl" />

        <Input
          label="Notes for friends and family"
          type="textarea"
          onChange={this.handleChange}
          name="description"
          value={regItemFields.description || ''}
          className={css.notes}
          placeholder={REG_ITEM_PLACEHOLDER_TEXT}
        />
      </React.Fragment>
    )
  }
}
